import type { HelpEntry } from '../types'

export const HELP: HelpEntry[] = [
  {
    id: 'playbooks.page',
    title: 'Playbooks',
    body: 'A playbook is a tested sequence of AI requests for one advisor job. Each step says what the AI does, what you check, the exact prompt, what to expect and why it matters. The same playbooks appear as prompts in Claude and ChatGPT and in the Excel sidebar.',
    verified_by: ['fusegrid_v2/capability_catalog/src/playbooks.rs:123', 'fusegrid_v2/server/src/platform/playbook_prompts.rs:44', 'fusegrid_v2/server/src/platform/mcp.rs:505'],
  },
  {
    id: 'playbooks.run',
    title: 'Running a playbook',
    body: 'Name the client and month, then copy the whole playbook into Claude or ChatGPT. The assistant runs one step at a time and waits for you between steps.',
    steps: ['Fill in the client and month.', 'Choose “Copy the whole playbook” and paste it into Claude or ChatGPT.', 'Or ask for it by name; the assistant starts it with the start_playbook tool.'],
    verified_by: ['fusegrid_v2/src/components/playbooks/playbooks.ts:47', 'fusegrid_v2/server/src/platform/playbook_prompts.rs:77'],
  },
  {
    id: 'playbooks.practice',
    title: 'Practice mode',
    body: 'Practice runs every step against a synthetic demo company in a separate demo session, so you can learn a playbook without touching a client. Requests that would change something come back as a proposal and are never applied.',
    limits: ['Your own sign-in is untouched; the demo session exists only on this page.'],
    verified_by: ['fusegrid_v2/src/components/playbooks/PlaybooksPage.tsx:51', 'fusegrid_v2/src/components/playbooks/PlaybooksPage.tsx:70', 'fusegrid_v2/server/src/platform/handholding.rs:380'],
  },
]
